import Link from "next/link";
import { PropsWithChildren } from "react";
import { useEntityContext } from "../useEntityContext";

export const EntityLink = (
  props: PropsWithChildren<{
    uuid: string;
    className?: string;
    style?: React.CSSProperties;
  }>
) => {
  const { orgId, setUuid, useHistory } = useEntityContext();
  return (
    <>
      {useHistory ? (
        <Link
          onClick={() => setUuid(props.uuid)}
          href="#"
          className={props.className}
          style={props.style}
        >
          {props.children}
        </Link>
      ) : (
        <Link
          href={`/${orgId}/entity/${props.uuid}`}
          target="_blank"
          rel="noreferrer"
          className={props.className}
          style={props.style}
        >
          {props.children}
        </Link>
      )}
    </>
  );
};
